import { render, staticRenderFns } from "./DropdownNormalContent.vue?vue&type=template&id=28a8e137&scoped=true"
import script from "./DropdownNormalContent.vue?vue&type=script&lang=js"
export * from "./DropdownNormalContent.vue?vue&type=script&lang=js"
import style0 from "./DropdownNormalContent.scss?vue&type=style&index=0&id=28a8e137&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a8e137",
  null
  
)

export default component.exports